import api from '../api/axios';

export interface Payment {
  id?: number;
  paymentNumber: string;
  invoice?: number;
  paymentDate: string;
  amount: number;
  paymentMethod: 'cash' | 'card' | 'bankTransfer' | 'check' | 'other';
  reference?: string;
  notes?: string;
  receivedBy?: number;
  receivedByName?: string;
  paymentReceipt?: number; // File ID for payment receipt/proof
  isExpense?: boolean;
  category?: string;
  description?: string;
  account?: number;
}

const PaymentService = {
  getAll: (params?: any) => api.get('/payments', { params }),
  getOne: (id: number, params?: any) => 
    api.get(`/payments/${id}`, { 
      params: params || { populate: ['invoice', 'invoice.customer', 'receivedBy', 'paymentReceipt'] } 
    }),
  create: (data: Payment) => api.post('/payments', { data }),
  update: (id: number, data: Partial<Payment>) => 
    api.put(`/payments/${id}`, { data }),
  delete: (id: number) => api.delete(`/payments/${id}`),
};

export default PaymentService;

